import { FormControl, FormGroup } from '@angular/forms';

import { SessionPreference } from '@sondermind/utilities/models-session';

export interface IQuickCheckoutForm {
  birthDate: FormControl<string | null>;
  commPrefs: FormGroup<{
    commPrefsPhone: FormControl<boolean | null>;
    commPrefsSms: FormControl<boolean | null>;
  }>;
  contactSmsAllowed: FormControl<boolean | null>;
  email: FormControl<string | null>;
  firstName: FormControl<string | null>;
  insurance: FormControl<number | null>;
  lastName: FormControl<string | null>;
  location: FormControl<string | null>;
  paymentType: FormControl<PaymentTypes | null>;
  phone: FormControl<string | null>;
  activeDuty: FormControl<boolean | null>;
  heardFrom: FormGroup<{
    source: FormControl<string | null>;
    details: FormControl<string | null>;
  }>;
}

export interface IQuickCheckoutFormValues {
  birthDate: string | null;
  commPrefs: {
    commPrefsPhone: boolean | null;
    commPrefsSms: boolean | null;
  };
  contactSmsAllowed: boolean | null;
  email: string | null;
  firstName: string | null;
  insurance: number | null;
  lastName: string | null;
  location: string | null;
  personaProviderId: number;
  phone: string | null;
  activeDuty: boolean | null;
  heardFrom: {
    source: string | null;
    details: string | null;
  };
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface IQuickCheckoutReferralCreationRequest {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  received_date: string;
  slot?: {
    start: string; // ISO string
    end: string; // ISO string
  };
  source_attributes: {
    segment_anonymous_id: string | null;
    session_format_preference: SessionPreference;
    state: string; // 'OH'
    source: string; // 'PSL Referral'
    referring_url?: string;
    submission_url: string;
    birthdate: string;
    insurance: number;
    persona_provider_id: number; // id of selected provider
    contact_sms_allowed: boolean;
    comm_prefs: string[];
    external_referral?: string; // 'google.com'
    external_referral_search?: string; // '?utm_source=google&utm_medium=cpc&utm_campaign=...'
    heard_from_source: string | null;
    heard_from_details: string | null;
    from_ai_connect?: boolean;
  };
  recaptcha_token: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface IQuickCheckoutReferralRequestCreationBody {
  first_name: string;
  last_name: string;
  phone: string;
  received_date: string;
  slot?: {
    start: string; // ISO string
    end: string; // ISO string
  };
  source_attributes: {
    segment_anonymous_id: string | null;
    session_format_preference: SessionPreference;
    state: string; // 'OH'
    source: string; // 'PSL Referral'
    birthdate: string;
    insurance: number;
    persona_provider_id: number; // id of selected provider
    contact_sms_allowed: boolean;
    comm_prefs: string[];
    external_referral?: string; // 'google.com'
    external_referral_search?: string; // '?utm_source=google&utm_medium=cpc&utm_campaign=...'
    heard_from_source: string | null;
    heard_from_details: string | null;
  };
  recaptcha_token: string;
}

export interface IQuickCheckoutReferralRequestResponse {
  saga_id: string;
}

export interface IQuickCheckoutApiResponse {
  referral_request_uuid: string;
  saga_id: string;
}

export interface ISagaStatusResponse {
  id: string;
  progress: SagaProgress;
}
/* eslint-enable @typescript-eslint/naming-convention */

export enum PaymentTypes {
  EAP = 'Employee assistance program (EAP)',
  MEDICARE = 'Medicare or Medicare Advantage',
  INSURANCE = 'Health insurance',
  MEDICAID = 'Medicaid',
  CASH = 'I\'ll pay for therapy myself'
}

export enum SagaProgress {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETE = 'complete',
  FAILED = 'failed'
}
